import { render } from "./MailingBlockImageEditor.vue?vue&type=template&id=67d23b0c"
import script from "./MailingBlockImageEditor.vue?vue&type=script&lang=js"
export * from "./MailingBlockImageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__